import { ComparisonCompareTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonCompare.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";
import {
    GoogleAnalyticsProduct,
    getGoogleAnalyticsProduct
} from "./GoogleAnalyticsProduct";

export interface GoogleAnalyticsComparisonCompareImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        products: Array<GoogleAnalyticsProduct>;
    };
}

export const getGoogleAnalyticsComparisonCompareImpression = (
    data: EnrichedAnalyticsEvent<ComparisonCompareTrackingInfo>
): GoogleAnalyticsComparisonCompareImpression => {
    const googleAnalyticsProducts = data.payload.eventData.products.map(
        getGoogleAnalyticsProduct
    );

    return {
        event: GoogleAnalyticsEvents.ComparisonCompare,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            products: googleAnalyticsProducts
        }
    };
};
